import React, { useCallback } from "react";
import { useLocation } from "react-router";
import { useTranslation } from "react-i18next";

import { ICustomer } from "redux/reducers/models/customer";
import DataTable from "components/dataTable/DataTable";

import "elements/register/register.scss";

interface ICustomerTableProps {
  /** undefined = table loader */
  customers: ICustomer[];
  onClick: (customer: ICustomer) => void;
  tableLimit: number;
  tableOffset: number;
  handlePagination: (direction: "prev" | "next") => void;
}

export default function CustomerTable(props: ICustomerTableProps) {
  const { t } = useTranslation();
  const location = useLocation<{ params: { customerId: number | string } }>();

  const elementScrollRef = useCallback((element: HTMLTableRowElement) => {
    const locationState = location.state;

    if (element !== null && locationState?.params?.customerId) {
      if (element.id === String(locationState.params.customerId)) {
        element.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
  }, []);

  return (
    <DataTable
      columns={[
        { label: t("Customer") },
        { label: t("Phone") },
        { label: t("Location") },
        { label: t("Membership") },
      ]}
      loading={props.customers === undefined}
      footer={{
        tableLimit: props.tableLimit,
        tableOffset: props.tableOffset,
        handleTableOffset: props.handlePagination,
        disableNextOffset: !props.customers || props.customers?.length < props.tableLimit,
      }}
    >
      {props.customers?.map(customer => (
        <tr
          key={customer.id}
          id={String(customer.id)}
          className="clickable"
          onClick={() => props.onClick(customer)}
          ref={elementScrollRef}
        >
          <td>
            <p>{customer.full_name}</p>
            <p>{customer.email}</p>
          </td>
          <td>
            {customer.phone ? (
              customer.phone
            ) : (
              <p className="field-unavailable">{t("No phone number")}</p>
            )}
          </td>
          <td>
            {customer.default_address_line ? (
              <p>
                {customer.default_address_line.city}, {customer.default_address_line.province_code}
              </p>
            ) : (
              <p className="field-unavailable">{t("No address available")}</p>
            )}
          </td>
          <td>
            {customer.customer_type ? <p>{customer.customer_type}</p> : null}
            {customer.cart_customer_type ? <p>{customer.cart_customer_type}</p> : null}
          </td>
        </tr>
      ))}
    </DataTable>
  );
}
